import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useMemo } from 'react';
import cx from 'classnames';
var css = {
  "horizontal": "oalp-pSEeR",
  "vertical": "oalp-3EEqa",
  "horizontalStep": "oalp-1zSF1",
  "subTitle": "oalp-1c6F2",
  "title": "oalp-3oBe1",
  "stepLabel": "oalp-2jfXZ",
  "stepSubLabel": "oalp-2siwT",
  "bullet": "oalp-1LEtZ",
  "progressLine": "oalp-1810i",
  "bulletTR": "oalp-2owFA",
  "last": "oalp-2KUSD",
  "progressLineTR": "oalp-2xpdR",
  "active": "oalp-2B4Oy",
  "horizontalStepWrapper": "oalp-I1OOG",
  "horizontalStepLeft": "oalp-1GdEB",
  "horizontalStepRight": "oalp-2UpUE"
};
import { SITECODES } from "../../Constants/siteCodes";
import { useConfig } from "../../ComponentDependency/useConfig";
var Step = function Step(_ref) {
  var step = _ref.step,
    alignment = _ref.alignment,
    isLast = _ref.isLast;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var config = useConfig();
  var isTR = useMemo(function () {
    return (config === null || config === void 0 ? void 0 : config.get('siteCode')) === SITECODES.OLXTR;
  }, [config]);
  var hasStepLeftContent = !!((_a = step === null || step === void 0 ? void 0 : step.stepLabel) === null || _a === void 0 ? void 0 : _a.text);
  if (alignment === 'horizontal') {
    var _cx;
    return /*#__PURE__*/React.createElement("div", {
      className: cx(css.horizontalStep, (_cx = {}, _defineProperty(_cx, css.active, step.isActive), _defineProperty(_cx, css.last, isLast), _cx))
    }, /*#__PURE__*/React.createElement("span", {
      className: cx(css.bullet, _defineProperty({}, css.bulletTR, isTR))
    }), /*#__PURE__*/React.createElement("span", {
      className: cx(css.progressLine, _defineProperty({}, css.progressLineTR, isTR))
    }), /*#__PURE__*/React.createElement("div", {
      className: css.horizontalStepWrapper
    }, hasStepLeftContent && /*#__PURE__*/React.createElement("div", {
      className: css.horizontalStepLeft
    }, step.stepLabel.text && /*#__PURE__*/React.createElement("p", {
      className: css.stepLabel,
      style: step.stepLabel.style
    }, step.stepLabel.text), ((_b = step === null || step === void 0 ? void 0 : step.stepSubLabel) === null || _b === void 0 ? void 0 : _b.text) && /*#__PURE__*/React.createElement("p", {
      className: css.stepSubLabel,
      style: (_c = step === null || step === void 0 ? void 0 : step.stepSubLabel) === null || _c === void 0 ? void 0 : _c.style
    }, (_d = step === null || step === void 0 ? void 0 : step.stepSubLabel) === null || _d === void 0 ? void 0 : _d.text)), /*#__PURE__*/React.createElement("div", {
      className: css.horizontalStepRight
    }, ((_e = step === null || step === void 0 ? void 0 : step.title) === null || _e === void 0 ? void 0 : _e.text) && /*#__PURE__*/React.createElement("h3", {
      className: css.title,
      style: (_f = step === null || step === void 0 ? void 0 : step.title) === null || _f === void 0 ? void 0 : _f.style
    }, (_g = step === null || step === void 0 ? void 0 : step.title) === null || _g === void 0 ? void 0 : _g.text), ((_h = step === null || step === void 0 ? void 0 : step.subTitle) === null || _h === void 0 ? void 0 : _h.text) && /*#__PURE__*/React.createElement("p", {
      className: css.subTitle,
      style: (_j = step === null || step === void 0 ? void 0 : step.subTitle) === null || _j === void 0 ? void 0 : _j.style
    }, (_k = step === null || step === void 0 ? void 0 : step.subTitle) === null || _k === void 0 ? void 0 : _k.text))));
  }
  return null;
};
export default Step;